import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { tap } from 'rxjs/operators';
import { TaskService } from 'src/modules/features/admin/services';
import { AuthenticationService } from '../../services/authentication';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  role: any;
  system: Array<any> = ['system_collaborator', 'system_admin'];
  department: Array<any> = ['collaborator'];
  permissions: Array<any> = [];
  filter: AppFilter;
  totalItems;
  constructor(
    private authSvc: AuthenticationService,
    private taskService: TaskService
  ) {
    this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    this.getPage(1);
    authSvc.user.subscribe((user) => {
      if (
        user &&
        this.system.indexOf(
          user.organizationId.organizationTypeId.organizationTypeId
        ) > -1
      ) {
        this.role = 'ADMIN';
      } else if (
        user &&
        this.department.indexOf(
          user.organizationId.organizationTypeId.organizationTypeId
        ) > -1
      ) {
        this.role = 'DEPART';
      }
    });

    if (window.localStorage.getItem('permissions')) {
      let authTokenPermission = JSON.parse(localStorage.getItem('permissions'));
      // this.permissions = JSON.parse(window.localStorage.getItem("permission"));
      this.permissions = authTokenPermission;
    }
  }

  checkPermission(id: string, action: string): boolean {
    if (
      this.permissions.filter((res) => res.permissionId === id)[0][action] ===
      'true'
    ) {
      return true;
    } else {
      return false;
    }
  }
  getPage(page) {
    this.filter['status'] = 'PENDING';
    this.taskService
      .getMyTasks({
        params: this.filter,
      })
      .pipe(
        tap((res) => {
          this.totalItems = +res['records'];
        })
      )
      .subscribe(
        (res) => {},
        (error) => {}
      );
  }
  ngOnInit(): void {}
}
